import { Modal } from "react-bootstrap";

export default function LoginModalPage(props) {
    return (
        <>
            <div className="modal-header justify-content-start">
                <h1 className="modal-title fs-5">Loyalty Login</h1>
            </div>
            <Modal.Body>
                <div className="col-12 d-flex flex-column justify-content-center gap-4 my-2">
                    <button type="button" className="btn btn-dark rounded-pill px-sm-5 px-3 mx-sm-5 mx-1" onClick={props.handleClickLoginLoyaltyMobile}>Login</button> 
                    <button type="button" className="btn btn-outline-dark rounded-pill px-sm-5 px-3 mx-sm-5 mx-1" onClick={props.handleClickCloseLoyaltyModal}>Continue as guest</button> 
                </div>
            </Modal.Body>
        </>
    )
}